"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CmpProfileConfigBase = exports.CmpProductTileBase = exports.CmpProductTabMain = exports.CmpProductTabFAQ = exports.CmpProductTabDetails = exports.CmpProductsTabComments = exports.CmpProductsCommentsItem = exports.CmpProductOfferTile = exports.CmpProductFAQItem = exports.CmpProductDetailItem = exports.CmpProductCartTileBase = exports.CmpPopYesNoCancelDialog = exports.CmpPopRightInfo = exports.CmpPopRightAuthBase = exports.CmpPopLeftFilter = exports.CmpPopCallbackDialog = exports.CmpPagination = exports.CmpFooter = exports.CmpFilterLineBase = exports.CmpCatalogItemTop = exports.CmpCatalogItem = exports.CmpCatalogBase = exports.CmpCartTotal = exports.CmpBreadcrumbs = exports.CmpBottomNavigationBase = exports.CmpArticleSaleTile = exports.CmpArticleNewsTile = exports.CmpArticleInfoTile = exports.CmpAdminTextEditor = exports.CmpAdminPublicationControl = exports.CmpAdminPagePagination = exports.CmpAdminListItemUser = exports.CmpAdminListItemSupport = exports.CmpAdminListItemProdReview = exports.CmpAdminListItemProdQuestion = exports.CmpAdminListItemHH = exports.CmpAdminListItemArticleNews = exports.CmpAdminListItemArticleInfo = exports.CmpAdminListHeadUser = exports.CmpAdminListHeadSupport = exports.CmpAdminListHeadProdReview = exports.CmpAdminListHeadProdQuestion = exports.CmpAdminListHeadHH = exports.CmpAdminListHeadArticleNews = exports.CmpAdminListHeadArticleInfo = exports.CmpAdminListFilter = exports.CmpAdminLeftMenuBase = exports.CmpAdminKeyWord = exports.CmpAdminJobApplicationsItem = exports.CmpAdminChatMessage = void 0;
exports.PageHeadHunt = exports.PageDocument = exports.PageContacts = exports.PageCart = exports.PageArticlesSale = exports.PageArticlesNewsAndInfo = exports.PageArticlesNews = exports.PageArticlesInfo = exports.PageAdminSelectPromotion = exports.PageAdminReview = exports.PageAdminProfileConfig = exports.PageAdminNewHH = exports.PageAdminNewArticleSale = exports.PageAdminNewArticle = exports.PageAdminList = exports.PageAdminHHAnswers = exports.PageAdminEmpty = exports.PageAdminCreateUser = exports.PageAdminCreateSearchItem = exports.PageAdminChat = exports.PageAboutCompany = exports.Page404 = exports.LayoutDesktopBase = exports.LayoutAdmin = exports.CmpWidgetSupplier = exports.CmpWidgetSaleBase = exports.CmpWidgetProductCategory = exports.CmpWidgetPMHistory = exports.CmpWidgetOfferGallery = exports.CmpWidgetOfferBase = exports.CmpWidgetLicenses = exports.CmpWidgetCategories = exports.CmpWidgetArticlesSale = exports.CmpWidgetArticlesNews = exports.CmpWidgetArticles = exports.CmpTopSearch = exports.CmpTopMenuMobileBase = exports.CmpTopMenuCartItem = exports.CmpTopMenuBase = exports.CmpTestMode = exports.CmpSliderControl = exports.CmpShareDropdown = exports.CmpProguctCategory = exports.CmpProfileSupport = exports.CmpProfileOrdersItemProduct = exports.CmpProfileOrdersItemBase = exports.CmpProfileOrdersBase = exports.CmpProfileNotifications = exports.CmpProfileNavigation = exports.CmpProfileFAQBase = void 0;
exports.PageProfile = exports.PageProductsFavouritesBase = exports.PageProducts = exports.PageProductAddComment = exports.PageProduct = exports.PageOrderNew = exports.PageNews = exports.PageMain = exports.PageLoading = exports.PageLegalInfo = void 0;
const gs = require("@ivanlog/gs");
class CmpAdminChatMessageControls {
    constructor(ctrls) {
        this.imgProfilePhoto = ctrls.get('imgProfilePhoto');
        this.lName = ctrls.get('lName');
        this.lDate = ctrls.get('lDate');
    }
}
class CmpAdminChatMessage extends gs.WrapperGS {
    constructor() {
        super("cmpAdminChatMessage");
        this.ctrls = new CmpAdminChatMessageControls(this._controls);
    }
}
exports.CmpAdminChatMessage = CmpAdminChatMessage;
class CmpAdminJobApplicationsItemControls {
    constructor(ctrls) {
        this.btnHide = ctrls.get('btnHide');
        this.lName = ctrls.get('lName');
        this.lPhone = ctrls.get('lPhone');
        this.lEmail = ctrls.get('lEmail');
        this.linkHeadHunter = ctrls.get('linkHeadHunter');
        this.lAbout = ctrls.get('lAbout');
        this.btnExpand = ctrls.get('btnExpand');
    }
}
class CmpAdminJobApplicationsItem extends gs.WrapperGS {
    constructor() {
        super("cmpAdminJobApplicationsItem");
        this.ctrls = new CmpAdminJobApplicationsItemControls(this._controls);
    }
}
exports.CmpAdminJobApplicationsItem = CmpAdminJobApplicationsItem;
class CmpAdminKeyWordControls {
    constructor(ctrls) {
        this.lName = ctrls.get('lName');
        this.btnCloseAnswerForm = ctrls.get('btnCloseAnswerForm');
    }
}
class CmpAdminKeyWord extends gs.WrapperGS {
    constructor() {
        super("cmpAdminKeyWord");
        this.ctrls = new CmpAdminKeyWordControls(this._controls);
    }
}
exports.CmpAdminKeyWord = CmpAdminKeyWord;
class CmpAdminLeftMenuBaseControls {
    constructor(ctrls) {
        this.btnArticles = ctrls.get('btnArticles');
        this.blockArticles = ctrls.get('blockArticles');
        this.lUsername = ctrls.get('lUsername');
        this.btnLogout = ctrls.get('btnLogout');
    }
}
class CmpAdminLeftMenuBase extends gs.WrapperGS {
    constructor() {
        super("cmpAdminLeftMenu");
        this.ctrls = new CmpAdminLeftMenuBaseControls(this._controls);
    }
}
exports.CmpAdminLeftMenuBase = CmpAdminLeftMenuBase;
class CmpAdminListFilterControls {
    constructor(ctrls) {
        this.lCount = ctrls.get('lCount');
    }
}
class CmpAdminListFilter extends gs.WrapperGS {
    constructor() {
        super("cmpAdminListFilter");
        this.ctrls = new CmpAdminListFilterControls(this._controls);
    }
}
exports.CmpAdminListFilter = CmpAdminListFilter;
class CmpAdminListHeadArticleInfoControls {
    constructor(ctrls) {
        this.cbSelected = ctrls.get('cbSelected');
    }
}
class CmpAdminListHeadArticleInfo extends gs.WrapperGS {
    constructor() {
        super("cmpAdminListHeadArticleInfo");
        this.ctrls = new CmpAdminListHeadArticleInfoControls(this._controls);
    }
}
exports.CmpAdminListHeadArticleInfo = CmpAdminListHeadArticleInfo;
class CmpAdminListHeadArticleNewsControls {
    constructor(ctrls) {
        this.cbSelected = ctrls.get('cbSelected');
    }
}
class CmpAdminListHeadArticleNews extends gs.WrapperGS {
    constructor() {
        super("cmpAdminListHeadArticleNews");
        this.ctrls = new CmpAdminListHeadArticleNewsControls(this._controls);
    }
}
exports.CmpAdminListHeadArticleNews = CmpAdminListHeadArticleNews;
class CmpAdminListHeadHHControls {
    constructor(ctrls) {
        this.cbSelected = ctrls.get('cbSelected');
    }
}
class CmpAdminListHeadHH extends gs.WrapperGS {
    constructor() {
        super("cmpAdminListHeadHH");
        this.ctrls = new CmpAdminListHeadHHControls(this._controls);
    }
}
exports.CmpAdminListHeadHH = CmpAdminListHeadHH;
class CmpAdminListHeadProdQuestionControls {
    constructor(ctrls) {
        this.cbSelected = ctrls.get('cbSelected');
    }
}
class CmpAdminListHeadProdQuestion extends gs.WrapperGS {
    constructor() {
        super("cmpAdminListHeadProdQuestion");
        this.ctrls = new CmpAdminListHeadProdQuestionControls(this._controls);
    }
}
exports.CmpAdminListHeadProdQuestion = CmpAdminListHeadProdQuestion;
class CmpAdminListHeadProdReviewControls {
    constructor(ctrls) {
        this.cbSelected = ctrls.get('cbSelected');
    }
}
class CmpAdminListHeadProdReview extends gs.WrapperGS {
    constructor() {
        super("cmpAdminListHeadProdReview");
        this.ctrls = new CmpAdminListHeadProdReviewControls(this._controls);
    }
}
exports.CmpAdminListHeadProdReview = CmpAdminListHeadProdReview;
class CmpAdminListHeadSupportControls {
    constructor(ctrls) {
        this.cbSelected = ctrls.get('cbSelected');
    }
}
class CmpAdminListHeadSupport extends gs.WrapperGS {
    constructor() {
        super("cmpAdminListHeadSupport");
        this.ctrls = new CmpAdminListHeadSupportControls(this._controls);
    }
}
exports.CmpAdminListHeadSupport = CmpAdminListHeadSupport;
class CmpAdminListHeadUserControls {
    constructor(ctrls) {
        this.cbSelected = ctrls.get('cbSelected');
    }
}
class CmpAdminListHeadUser extends gs.WrapperGS {
    constructor() {
        super("cmpAdminListHeadUser");
        this.ctrls = new CmpAdminListHeadUserControls(this._controls);
    }
}
exports.CmpAdminListHeadUser = CmpAdminListHeadUser;
class CmpAdminListItemArticleInfoControls {
    constructor(ctrls) {
        this.cbSelected = ctrls.get('cbSelected');
    }
}
class CmpAdminListItemArticleInfo extends gs.WrapperGS {
    constructor() {
        super("cmpAdminListItemArticleInfo");
        this.ctrls = new CmpAdminListItemArticleInfoControls(this._controls);
    }
}
exports.CmpAdminListItemArticleInfo = CmpAdminListItemArticleInfo;
class CmpAdminListItemArticleNewsControls {
    constructor(ctrls) {
        this.cbSelected = ctrls.get('cbSelected');
    }
}
class CmpAdminListItemArticleNews extends gs.WrapperGS {
    constructor() {
        super("cmpAdminListItemArticleNews");
        this.ctrls = new CmpAdminListItemArticleNewsControls(this._controls);
    }
}
exports.CmpAdminListItemArticleNews = CmpAdminListItemArticleNews;
class CmpAdminListItemHHControls {
    constructor(ctrls) {
        this.cbSelected = ctrls.get('cbSelected');
    }
}
class CmpAdminListItemHH extends gs.WrapperGS {
    constructor() {
        super("cmpAdminListItemHH");
        this.ctrls = new CmpAdminListItemHHControls(this._controls);
    }
}
exports.CmpAdminListItemHH = CmpAdminListItemHH;
class CmpAdminListItemProdQuestionControls {
    constructor(ctrls) {
        this.cbSelected = ctrls.get('cbSelected');
    }
}
class CmpAdminListItemProdQuestion extends gs.WrapperGS {
    constructor() {
        super("cmpAdminListItemProdQuestion");
        this.ctrls = new CmpAdminListItemProdQuestionControls(this._controls);
    }
}
exports.CmpAdminListItemProdQuestion = CmpAdminListItemProdQuestion;
class CmpAdminListItemProdReviewControls {
    constructor(ctrls) {
        this.cbSelected = ctrls.get('cbSelected');
    }
}
class CmpAdminListItemProdReview extends gs.WrapperGS {
    constructor() {
        super("cmpAdminListItemProdReview");
        this.ctrls = new CmpAdminListItemProdReviewControls(this._controls);
    }
}
exports.CmpAdminListItemProdReview = CmpAdminListItemProdReview;
class CmpAdminListItemSupportControls {
    constructor(ctrls) {
        this.cbSelected = ctrls.get('cbSelected');
    }
}
class CmpAdminListItemSupport extends gs.WrapperGS {
    constructor() {
        super("cmpAdminListItemSupport");
        this.ctrls = new CmpAdminListItemSupportControls(this._controls);
    }
}
exports.CmpAdminListItemSupport = CmpAdminListItemSupport;
class CmpAdminListItemUserControls {
    constructor(ctrls) {
        this.cbSelected = ctrls.get('cbSelected');
    }
}
class CmpAdminListItemUser extends gs.WrapperGS {
    constructor() {
        super("cmpAdminListItemUser");
        this.ctrls = new CmpAdminListItemUserControls(this._controls);
    }
}
exports.CmpAdminListItemUser = CmpAdminListItemUser;
class CmpAdminPagePaginationControls {
    constructor(ctrls) {
    }
}
class CmpAdminPagePagination extends gs.WrapperGS {
    constructor() {
        super("cmpAdminPagePagination");
        this.ctrls = new CmpAdminPagePaginationControls(this._controls);
    }
}
exports.CmpAdminPagePagination = CmpAdminPagePagination;
class CmpAdminPublicationControlControls {
    constructor(ctrls) {
        this.lStatus = ctrls.get('lStatus');
        this.lVisibility = ctrls.get('lVisibility');
        this.btnDelete = ctrls.get('btnDelete');
    }
}
class CmpAdminPublicationControl extends gs.WrapperGS {
    constructor() {
        super("cmpAdminPublicationControl");
        this.ctrls = new CmpAdminPublicationControlControls(this._controls);
    }
}
exports.CmpAdminPublicationControl = CmpAdminPublicationControl;
class CmpAdminTextEditorControls {
    constructor(ctrls) {
        this.editor = ctrls.get('editor');
        this.lWordsNumber = ctrls.get('lWordsNumber');
    }
}
class CmpAdminTextEditor extends gs.WrapperGS {
    constructor() {
        super("cmpAdminTextEditor");
        this.ctrls = new CmpAdminTextEditorControls(this._controls);
    }
}
exports.CmpAdminTextEditor = CmpAdminTextEditor;
class CmpArticleInfoTileControls {
    constructor(ctrls) {
        this.lTag = ctrls.get('lTag');
        this.lTitle = ctrls.get('lTitle');
    }
}
class CmpArticleInfoTile extends gs.WrapperGS {
    constructor() {
        super("cmpArticleInfoTile");
        this.ctrls = new CmpArticleInfoTileControls(this._controls);
    }
}
exports.CmpArticleInfoTile = CmpArticleInfoTile;
class CmpArticleNewsTileControls {
    constructor(ctrls) {
    }
}
class CmpArticleNewsTile extends gs.WrapperGS {
    constructor() {
        super("cmpArticleNewsTile");
        this.ctrls = new CmpArticleNewsTileControls(this._controls);
    }
}
exports.CmpArticleNewsTile = CmpArticleNewsTile;
class CmpArticleSaleTileControls {
    constructor(ctrls) {
    }
}
class CmpArticleSaleTile extends gs.WrapperGS {
    constructor() {
        super("cmpArticleSaleTile");
        this.ctrls = new CmpArticleSaleTileControls(this._controls);
    }
}
exports.CmpArticleSaleTile = CmpArticleSaleTile;
class CmpBottomNavigationBaseControls {
    constructor(ctrls) {
        this.linkMain = ctrls.get('linkMain');
        this.btnCatalog = ctrls.get('btnCatalog');
        this.linkCart = ctrls.get('linkCart');
        this.lCartCount = ctrls.get('lCartCount');
        this.linkFavourite = ctrls.get('linkFavourite');
        this.lFavouriteCount = ctrls.get('lFavouriteCount');
        this.btnProfile = ctrls.get('btnProfile');
    }
}
class CmpBottomNavigationBase extends gs.WrapperGS {
    constructor() {
        super("cmpBottomNavigation");
        this.ctrls = new CmpBottomNavigationBaseControls(this._controls);
    }
}
exports.CmpBottomNavigationBase = CmpBottomNavigationBase;
class CmpBreadcrumbsControls {
    constructor(ctrls) {
        this.list = ctrls.get('list');
    }
}
class CmpBreadcrumbs extends gs.WrapperGS {
    constructor() {
        super("cmpBreadcrumbs");
        this.ctrls = new CmpBreadcrumbsControls(this._controls);
    }
}
exports.CmpBreadcrumbs = CmpBreadcrumbs;
class CmpCartTotalControls {
    constructor(ctrls) {
        this.lCostTotal = ctrls.get('lCostTotal');
        this.lCount = ctrls.get('lCount');
        this.lCostDetailsTotal = ctrls.get('lCostDetailsTotal');
        this.blockDelivery = ctrls.get('blockDelivery');
        this.lCostDetailsDelivery = ctrls.get('lCostDetailsDelivery');
        this.blockDiscount = ctrls.get('blockDiscount');
        this.lCostDetailsDiscount = ctrls.get('lCostDetailsDiscount');
        this.btnSubmit = ctrls.get('btnSubmit');
    }
}
class CmpCartTotal extends gs.WrapperGS {
    constructor() {
        super("cmpCartTotal");
        this.ctrls = new CmpCartTotalControls(this._controls);
    }
}
exports.CmpCartTotal = CmpCartTotal;
class CmpCatalogBaseControls {
    constructor(ctrls) {
        this.blockCategories = ctrls.get('blockCategories');
        this.ulCategories = ctrls.get('ulCategories');
        this.blockSubCategories = ctrls.get('blockSubCategories');
        this.lCategoryTitle = ctrls.get('lCategoryTitle');
        this.ulSubCategoryCol1 = ctrls.get('ulSubCategoryCol1');
        this.ulSubCategoryCol2 = ctrls.get('ulSubCategoryCol2');
        this.ulSubCategoryColMobile = ctrls.get('ulSubCategoryColMobile');
    }
}
class CmpCatalogBase extends gs.WrapperGS {
    constructor() {
        super("cmpCatalog");
        this.ctrls = new CmpCatalogBaseControls(this._controls);
    }
}
exports.CmpCatalogBase = CmpCatalogBase;
class CmpCatalogItemControls {
    constructor(ctrls) {
        this.label = ctrls.get('label');
        this.list = ctrls.get('list');
    }
}
class CmpCatalogItem extends gs.WrapperGS {
    constructor() {
        super("cmpCatalogItem");
        this.ctrls = new CmpCatalogItemControls(this._controls);
    }
}
exports.CmpCatalogItem = CmpCatalogItem;
class CmpCatalogItemTopControls {
    constructor(ctrls) {
        this.btn = ctrls.get('btn');
        this.svgIcon = ctrls.get('svgIcon');
        this.label = ctrls.get('label');
    }
}
class CmpCatalogItemTop extends gs.WrapperGS {
    constructor() {
        super("cmpCatalogItemTop");
        this.ctrls = new CmpCatalogItemTopControls(this._controls);
    }
}
exports.CmpCatalogItemTop = CmpCatalogItemTop;
class CmpFilterLineBaseControls {
    constructor(ctrls) {
        this.btnFilter = ctrls.get('btnFilter');
        this.btnFilterInStock = ctrls.get('btnFilterInStock');
        this.cbFilterInStock = ctrls.get('cbFilterInStock');
        this.optionsSelected = ctrls.get('optionsSelected');
        this.optionsList = ctrls.get('optionsList');
        this.lFoundedCount = ctrls.get('lFoundedCount');
        this.blockFilterTags = ctrls.get('blockFilterTags');
        this.listFilterTags = ctrls.get('listFilterTags');
        this.btnResetFilters = ctrls.get('btnResetFilters');
    }
}
class CmpFilterLineBase extends gs.WrapperGS {
    constructor() {
        super("cmpFilterLine");
        this.ctrls = new CmpFilterLineBaseControls(this._controls);
    }
}
exports.CmpFilterLineBase = CmpFilterLineBase;
class CmpFooterControls {
    constructor(ctrls) {
    }
}
class CmpFooter extends gs.WrapperGS {
    constructor() {
        super("cmpFooter");
        this.ctrls = new CmpFooterControls(this._controls);
    }
}
exports.CmpFooter = CmpFooter;
class CmpPaginationControls {
    constructor(ctrls) {
        this.btnNext = ctrls.get('btnNext');
        this.blockPagination = ctrls.get('blockPagination');
    }
}
class CmpPagination extends gs.WrapperGS {
    constructor() {
        super("cmpPagination");
        this.ctrls = new CmpPaginationControls(this._controls);
    }
}
exports.CmpPagination = CmpPagination;
class CmpPopCallbackDialogControls {
    constructor(ctrls) {
        this.btnClose = ctrls.get('btnClose');
        this.blockCall = ctrls.get('blockCall');
        this.blockQuestion = ctrls.get('blockQuestion');
        this.blockVacancy = ctrls.get('blockVacancy');
        this.blockComplaint = ctrls.get('blockComplaint');
    }
}
class CmpPopCallbackDialog extends gs.WrapperGS {
    constructor() {
        super("cmpPopCallbackDialog");
        this.ctrls = new CmpPopCallbackDialogControls(this._controls);
    }
}
exports.CmpPopCallbackDialog = CmpPopCallbackDialog;
class CmpPopLeftFilterControls {
    constructor(ctrls) {
        this.lPopTitle = ctrls.get('lPopTitle');
        this.btnClose = ctrls.get('btnClose');
        this.iRangeMin = ctrls.get('iRangeMin');
        this.iRangeMax = ctrls.get('iRangeMax');
        this.btnShowProducts = ctrls.get('btnShowProducts');
        this.lFounedProduct = ctrls.get('lFounedProduct');
    }
}
class CmpPopLeftFilter extends gs.WrapperGS {
    constructor() {
        super("cmpPopLeftFilter");
        this.ctrls = new CmpPopLeftFilterControls(this._controls);
    }
}
exports.CmpPopLeftFilter = CmpPopLeftFilter;
class CmpPopRightAuthBaseControls {
    constructor(ctrls) {
        this.backgroud = ctrls.get('backgroud');
        this.btnClose = ctrls.get('btnClose');
        this.blockPhone = ctrls.get('blockPhone');
        this.iPhone = ctrls.get('iPhone');
        this.lErrorPhone = ctrls.get('lErrorPhone');
        this.btnChangePhone = ctrls.get('btnChangePhone');
        this.blockCode = ctrls.get('blockCode');
        this.iCode0 = ctrls.get('iCode0');
        this.iCode1 = ctrls.get('iCode1');
        this.iCode2 = ctrls.get('iCode2');
        this.iCode3 = ctrls.get('iCode3');
        this.lResendCodeTimer = ctrls.get('lResendCodeTimer');
        this.lResendCodeTime = ctrls.get('lResendCodeTime');
        this.btnResendCode = ctrls.get('btnResendCode');
        this.lErrorSMS = ctrls.get('lErrorSMS');
        this.btnSendCode = ctrls.get('btnSendCode');
        this.btnSubmitCode = ctrls.get('btnSubmitCode');
    }
}
class CmpPopRightAuthBase extends gs.WrapperGS {
    constructor() {
        super("cmpPopRightAuth");
        this.ctrls = new CmpPopRightAuthBaseControls(this._controls);
    }
}
exports.CmpPopRightAuthBase = CmpPopRightAuthBase;
class CmpPopRightInfoControls {
    constructor(ctrls) {
        this.lPopTitle = ctrls.get('lPopTitle');
        this.btnClose = ctrls.get('btnClose');
    }
}
class CmpPopRightInfo extends gs.WrapperGS {
    constructor() {
        super("cmpPopRightInfo");
        this.ctrls = new CmpPopRightInfoControls(this._controls);
    }
}
exports.CmpPopRightInfo = CmpPopRightInfo;
class CmpPopYesNoCancelDialogControls {
    constructor(ctrls) {
        this.btnClose = ctrls.get('btnClose');
        this.blockCall = ctrls.get('blockCall');
        this.lHeader = ctrls.get('lHeader');
        this.lText = ctrls.get('lText');
        this.btnYes = ctrls.get('btnYes');
        this.btnNo = ctrls.get('btnNo');
        this.btnCancel = ctrls.get('btnCancel');
    }
}
class CmpPopYesNoCancelDialog extends gs.WrapperGS {
    constructor() {
        super("cmpPopYesNoCancelDialog");
        this.ctrls = new CmpPopYesNoCancelDialogControls(this._controls);
    }
}
exports.CmpPopYesNoCancelDialog = CmpPopYesNoCancelDialog;
class CmpProductCartTileBaseControls {
    constructor(ctrls) {
        this.cbSelected = ctrls.get('cbSelected');
        this.img1 = ctrls.get('img1');
        this.blockRate = ctrls.get('blockRate');
        this.lRate = ctrls.get('lRate');
        this.statusOk = ctrls.get('statusOk');
        this.lRemainderCount = ctrls.get('lRemainderCount');
        this.statusNone = ctrls.get('statusNone');
        this.statusDelivery = ctrls.get('statusDelivery');
        this.aName = ctrls.get('aName');
        this.lArticle = ctrls.get('lArticle');
        this.btnQtyDown = ctrls.get('btnQtyDown');
        this.lQty = ctrls.get('lQty');
        this.btnQtyUp = ctrls.get('btnQtyUp');
        this.lPrice = ctrls.get('lPrice');
        this.lDiscount = ctrls.get('lDiscount');
        this.lCost = ctrls.get('lCost');
        this.lCostOld = ctrls.get('lCostOld');
        this.btnDelete = ctrls.get('btnDelete');
        this.btnFavorite = ctrls.get('btnFavorite');
        this.listProductOffers = ctrls.get('listProductOffers');
    }
}
class CmpProductCartTileBase extends gs.WrapperGS {
    constructor() {
        super("cmpProductCartTile");
        this.ctrls = new CmpProductCartTileBaseControls(this._controls);
    }
}
exports.CmpProductCartTileBase = CmpProductCartTileBase;
class CmpProductDetailItemControls {
    constructor(ctrls) {
        this.lName = ctrls.get('lName');
        this.lValue = ctrls.get('lValue');
        this.btnArticle = ctrls.get('btnArticle');
    }
}
class CmpProductDetailItem extends gs.WrapperGS {
    constructor() {
        super("cmpProductDetailItem");
        this.ctrls = new CmpProductDetailItemControls(this._controls);
    }
}
exports.CmpProductDetailItem = CmpProductDetailItem;
class CmpProductFAQItemControls {
    constructor(ctrls) {
        this.lName = ctrls.get('lName');
        this.lBirthDate = ctrls.get('lBirthDate');
        this.lQuestionText = ctrls.get('lQuestionText');
        this.btnAnswer = ctrls.get('btnAnswer');
        this.btnLike = ctrls.get('btnLike');
        this.lLikesQuantity = ctrls.get('lLikesQuantity');
        this.btnDisike = ctrls.get('btnDisike');
        this.lDislikesQuantity = ctrls.get('lDislikesQuantity');
        this.formAnswer = ctrls.get('formAnswer');
        this.btnCloseAnswerForm = ctrls.get('btnCloseAnswerForm');
        this.blockAnswers = ctrls.get('blockAnswers');
    }
}
class CmpProductFAQItem extends gs.WrapperGS {
    constructor() {
        super("cmpProductFAQItem");
        this.ctrls = new CmpProductFAQItemControls(this._controls);
    }
}
exports.CmpProductFAQItem = CmpProductFAQItem;
class CmpProductOfferTileControls {
    constructor(ctrls) {
    }
}
class CmpProductOfferTile extends gs.WrapperGS {
    constructor() {
        super("cmpProductOfferTile");
        this.ctrls = new CmpProductOfferTileControls(this._controls);
    }
}
exports.CmpProductOfferTile = CmpProductOfferTile;
class CmpProductsCommentsItemControls {
    constructor(ctrls) {
    }
}
class CmpProductsCommentsItem extends gs.WrapperGS {
    constructor() {
        super("cmpProductsCommentsItem");
        this.ctrls = new CmpProductsCommentsItemControls(this._controls);
    }
}
exports.CmpProductsCommentsItem = CmpProductsCommentsItem;
class CmpProductsTabCommentsControls {
    constructor(ctrls) {
    }
}
class CmpProductsTabComments extends gs.WrapperGS {
    constructor() {
        super("cmpProductsTabComments");
        this.ctrls = new CmpProductsTabCommentsControls(this._controls);
    }
}
exports.CmpProductsTabComments = CmpProductsTabComments;
class CmpProductTabDetailsControls {
    constructor(ctrls) {
        this.list = ctrls.get('list');
    }
}
class CmpProductTabDetails extends gs.WrapperGS {
    constructor() {
        super("cmpProductTabDetails");
        this.ctrls = new CmpProductTabDetailsControls(this._controls);
    }
}
exports.CmpProductTabDetails = CmpProductTabDetails;
class CmpProductTabFAQControls {
    constructor(ctrls) {
        this.listQuestions = ctrls.get('listQuestions');
    }
}
class CmpProductTabFAQ extends gs.WrapperGS {
    constructor() {
        super("cmpProductTabFAQ");
        this.ctrls = new CmpProductTabFAQControls(this._controls);
    }
}
exports.CmpProductTabFAQ = CmpProductTabFAQ;
class CmpProductTabMainControls {
    constructor(ctrls) {
        this.lDescription = ctrls.get('lDescription');
    }
}
class CmpProductTabMain extends gs.WrapperGS {
    constructor() {
        super("cmpProductTabMain");
        this.ctrls = new CmpProductTabMainControls(this._controls);
    }
}
exports.CmpProductTabMain = CmpProductTabMain;
class CmpProductTileBaseControls {
    constructor(ctrls) {
        this.aImg = ctrls.get('aImg');
        this.img1 = ctrls.get('img1');
        this.img2 = ctrls.get('img2');
        this.btnCompare = ctrls.get('btnCompare');
        this.btnFavorite = ctrls.get('btnFavorite');
        this.lPrice = ctrls.get('lPrice');
        this.lPriceOld = ctrls.get('lPriceOld');
        this.blockBonus = ctrls.get('blockBonus');
        this.lBonus = ctrls.get('lBonus');
        this.aName = ctrls.get('aName');
        this.blockRate = ctrls.get('blockRate');
        this.lRate = ctrls.get('lRate');
        this.statusOk = ctrls.get('statusOk');
        this.lRemainderCount = ctrls.get('lRemainderCount');
        this.statusNone = ctrls.get('statusNone');
        this.statusDelivery = ctrls.get('statusDelivery');
        this.btnAddToCart = ctrls.get('btnAddToCart');
    }
}
class CmpProductTileBase extends gs.WrapperGS {
    constructor() {
        super("cmpProductTile");
        this.ctrls = new CmpProductTileBaseControls(this._controls);
    }
}
exports.CmpProductTileBase = CmpProductTileBase;
class CmpProfileConfigBaseControls {
    constructor(ctrls) {
        this.imgProfilePhoto = ctrls.get('imgProfilePhoto');
        this.btnChangePhoto = ctrls.get('btnChangePhoto');
        this.lName = ctrls.get('lName');
        this.lRegDate = ctrls.get('lRegDate');
        this.iName = ctrls.get('iName');
        this.iBirthDate = ctrls.get('iBirthDate');
        this.iPhone = ctrls.get('iPhone');
        this.iEmail = ctrls.get('iEmail');
        this.btnSave = ctrls.get('btnSave');
        this.btnChangePhone = ctrls.get('btnChangePhone');
        this.btnDeleteProfile = ctrls.get('btnDeleteProfile');
    }
}
class CmpProfileConfigBase extends gs.WrapperGS {
    constructor() {
        super("cmpProfileConfig");
        this.ctrls = new CmpProfileConfigBaseControls(this._controls);
    }
}
exports.CmpProfileConfigBase = CmpProfileConfigBase;
class CmpProfileFAQBaseControls {
    constructor(ctrls) {
        this.list = ctrls.get('list');
    }
}
class CmpProfileFAQBase extends gs.WrapperGS {
    constructor() {
        super("cmpProfileFAQ");
        this.ctrls = new CmpProfileFAQBaseControls(this._controls);
    }
}
exports.CmpProfileFAQBase = CmpProfileFAQBase;
class CmpProfileNavigationControls {
    constructor(ctrls) {
        this.imgProfilePhoto = ctrls.get('imgProfilePhoto');
        this.lProfileName = ctrls.get('lProfileName');
        this.lProfilePhone = ctrls.get('lProfilePhone');
        this.aOrders = ctrls.get('aOrders');
        this.aFavourites = ctrls.get('aFavourites');
        this.lFavouriteCount = ctrls.get('lFavouriteCount');
        this.aReviews = ctrls.get('aReviews');
        this.aCompare = ctrls.get('aCompare');
        this.aConfig = ctrls.get('aConfig');
        this.aBonus = ctrls.get('aBonus');
        this.aCompanies = ctrls.get('aCompanies');
        this.aSupport = ctrls.get('aSupport');
        this.aFAQ = ctrls.get('aFAQ');
        this.aNotification = ctrls.get('aNotification');
        this.aLogout = ctrls.get('aLogout');
    }
}
class CmpProfileNavigation extends gs.WrapperGS {
    constructor() {
        super("cmpProfileNavigation");
        this.ctrls = new CmpProfileNavigationControls(this._controls);
    }
}
exports.CmpProfileNavigation = CmpProfileNavigation;
class CmpProfileNotificationsControls {
    constructor(ctrls) {
    }
}
class CmpProfileNotifications extends gs.WrapperGS {
    constructor() {
        super("cmpProfileNotifications");
        this.ctrls = new CmpProfileNotificationsControls(this._controls);
    }
}
exports.CmpProfileNotifications = CmpProfileNotifications;
class CmpProfileOrdersBaseControls {
    constructor(ctrls) {
        this.btnFilterAll = ctrls.get('btnFilterAll');
        this.btnFilterActive = ctrls.get('btnFilterActive');
        this.btnFilterCompleted = ctrls.get('btnFilterCompleted');
        this.btnFilterCanceled = ctrls.get('btnFilterCanceled');
        this.lStatusFilter = ctrls.get('lStatusFilter');
        this.rbFilterAll = ctrls.get('rbFilterAll');
        this.rbFilterActive = ctrls.get('rbFilterActive');
        this.rbFilterCompleted = ctrls.get('rbFilterCompleted');
        this.rbFilterCanceled = ctrls.get('rbFilterCanceled');
        this.lStatusDate = ctrls.get('lStatusDate');
        this.listOrders = ctrls.get('listOrders');
    }
}
class CmpProfileOrdersBase extends gs.WrapperGS {
    constructor() {
        super("cmpProfileOrders");
        this.ctrls = new CmpProfileOrdersBaseControls(this._controls);
    }
}
exports.CmpProfileOrdersBase = CmpProfileOrdersBase;
class CmpProfileOrdersItemBaseControls {
    constructor(ctrls) {
        this.btnHeader = ctrls.get('btnHeader');
        this.lOrderId = ctrls.get('lOrderId');
        this.lCreateDate = ctrls.get('lCreateDate');
        this.lStatus = ctrls.get('lStatus');
        this.lStatusDescription = ctrls.get('lStatusDescription');
        this.lDeliveryType = ctrls.get('lDeliveryType');
        this.lPaymentType = ctrls.get('lPaymentType');
        this.lCustomerName = ctrls.get('lCustomerName');
        this.listProducts = ctrls.get('listProducts');
        this.lDeliveryCost = ctrls.get('lDeliveryCost');
        this.lTotalCost = ctrls.get('lTotalCost');
        this.blockBonus = ctrls.get('blockBonus');
        this.lBonusCount = ctrls.get('lBonusCount');
        this.btnDeleteOrder = ctrls.get('btnDeleteOrder');
        this.btnPayOrder = ctrls.get('btnPayOrder');
        this.btnRepeatOrder = ctrls.get('btnRepeatOrder');
    }
}
class CmpProfileOrdersItemBase extends gs.WrapperGS {
    constructor() {
        super("cmpProfileOrdersItem");
        this.ctrls = new CmpProfileOrdersItemBaseControls(this._controls);
    }
}
exports.CmpProfileOrdersItemBase = CmpProfileOrdersItemBase;
class CmpProfileOrdersItemProductControls {
    constructor(ctrls) {
        this.imgProductImage = ctrls.get('imgProductImage');
        this.lSku = ctrls.get('lSku');
        this.lTitle = ctrls.get('lTitle');
        this.btnReview = ctrls.get('btnReview');
        this.lPrice = ctrls.get('lPrice');
        this.lQuantity = ctrls.get('lQuantity');
        this.lUnitPrice = ctrls.get('lUnitPrice');
    }
}
class CmpProfileOrdersItemProduct extends gs.WrapperGS {
    constructor() {
        super("cmpProfileOrdersItemProduct");
        this.ctrls = new CmpProfileOrdersItemProductControls(this._controls);
    }
}
exports.CmpProfileOrdersItemProduct = CmpProfileOrdersItemProduct;
class CmpProfileSupportControls {
    constructor(ctrls) {
        this.lPrivacyWarning = ctrls.get('lPrivacyWarning');
    }
}
class CmpProfileSupport extends gs.WrapperGS {
    constructor() {
        super("cmpProfileSupport");
        this.ctrls = new CmpProfileSupportControls(this._controls);
    }
}
exports.CmpProfileSupport = CmpProfileSupport;
class CmpProguctCategoryControls {
    constructor(ctrls) {
    }
}
class CmpProguctCategory extends gs.WrapperGS {
    constructor() {
        super("cmpProguctCategory");
        this.ctrls = new CmpProguctCategoryControls(this._controls);
    }
}
exports.CmpProguctCategory = CmpProguctCategory;
class CmpShareDropdownControls {
    constructor(ctrls) {
    }
}
class CmpShareDropdown extends gs.WrapperGS {
    constructor() {
        super("cmpShareDropdown");
        this.ctrls = new CmpShareDropdownControls(this._controls);
    }
}
exports.CmpShareDropdown = CmpShareDropdown;
class CmpSliderControlControls {
    constructor(ctrls) {
        this.label = ctrls.get('label');
        this.blockPagintaion = ctrls.get('blockPagintaion');
        this.btnPrev = ctrls.get('btnPrev');
        this.btnNext = ctrls.get('btnNext');
    }
}
class CmpSliderControl extends gs.WrapperGS {
    constructor() {
        super("cmpSliderControl");
        this.ctrls = new CmpSliderControlControls(this._controls);
    }
}
exports.CmpSliderControl = CmpSliderControl;
class CmpTestModeControls {
    constructor(ctrls) {
        this.iPassword = ctrls.get('iPassword');
        this.btn = ctrls.get('btn');
    }
}
class CmpTestMode extends gs.WrapperGS {
    constructor() {
        super("cmpTestMode");
        this.ctrls = new CmpTestModeControls(this._controls);
    }
}
exports.CmpTestMode = CmpTestMode;
class CmpTopMenuBaseControls {
    constructor(ctrls) {
        this.blockAbout = ctrls.get('blockAbout');
        this.blockClient = ctrls.get('blockClient');
        this.btnCatalog = ctrls.get('btnCatalog');
        this.iSearchQuery = ctrls.get('iSearchQuery');
        this.btnResetInput = ctrls.get('btnResetInput');
        this.btnSearch = ctrls.get('btnSearch');
        this.blockSearchResult = ctrls.get('blockSearchResult');
        this.cmpSearchResult = ctrls.get('cmpSearchResult');
        this.btnCompare = ctrls.get('btnCompare');
        this.lFavouriteCount = ctrls.get('lFavouriteCount');
        this.lCartCount = ctrls.get('lCartCount');
        this.blockCartDrop = ctrls.get('blockCartDrop');
        this.listTopMenuCartItems = ctrls.get('listTopMenuCartItems');
        this.btnProfile = ctrls.get('btnProfile');
        this.lUserName = ctrls.get('lUserName');
        this.lUserPhoto = ctrls.get('lUserPhoto');
        this.blockCatalog = ctrls.get('blockCatalog');
        this.cmpCatalog = ctrls.get('cmpCatalog');
    }
}
class CmpTopMenuBase extends gs.WrapperGS {
    constructor() {
        super("cmpTopMenu");
        this.ctrls = new CmpTopMenuBaseControls(this._controls);
    }
}
exports.CmpTopMenuBase = CmpTopMenuBase;
class CmpTopMenuCartItemControls {
    constructor(ctrls) {
        this.lTitle = ctrls.get('lTitle');
        this.lPrice = ctrls.get('lPrice');
        this.lOldPrice = ctrls.get('lOldPrice');
        this.btnDelete = ctrls.get('btnDelete');
    }
}
class CmpTopMenuCartItem extends gs.WrapperGS {
    constructor() {
        super("cmpTopMenuCartItem");
        this.ctrls = new CmpTopMenuCartItemControls(this._controls);
    }
}
exports.CmpTopMenuCartItem = CmpTopMenuCartItem;
class CmpTopMenuMobileBaseControls {
    constructor(ctrls) {
        this.btnMenu = ctrls.get('btnMenu');
        this.btnBack = ctrls.get('btnBack');
        this.iSearchQuery = ctrls.get('iSearchQuery');
        this.btnResetInput = ctrls.get('btnResetInput');
        this.btnClose = ctrls.get('btnClose');
        this.listMenu = ctrls.get('listMenu');
        this.btnCatalog = ctrls.get('btnCatalog');
        this.btnAbout = ctrls.get('btnAbout');
        this.btnForClients = ctrls.get('btnForClients');
        this.listAbout = ctrls.get('listAbout');
        this.listForClients = ctrls.get('listForClients');
        this.cmpCatalog = ctrls.get('cmpCatalog');
    }
}
class CmpTopMenuMobileBase extends gs.WrapperGS {
    constructor() {
        super("cmpTopMenuMobile");
        this.ctrls = new CmpTopMenuMobileBaseControls(this._controls);
    }
}
exports.CmpTopMenuMobileBase = CmpTopMenuMobileBase;
class CmpTopSearchControls {
    constructor(ctrls) {
        this.blockHeader = ctrls.get('blockHeader');
        this.btnClearHistory = ctrls.get('btnClearHistory');
        this.listHistory = ctrls.get('listHistory');
        this.listTopMenuCartItems = ctrls.get('listTopMenuCartItems');
        this.lLinkCategory = ctrls.get('lLinkCategory');
    }
}
class CmpTopSearch extends gs.WrapperGS {
    constructor() {
        super("cmpTopSearch");
        this.ctrls = new CmpTopSearchControls(this._controls);
    }
}
exports.CmpTopSearch = CmpTopSearch;
class CmpWidgetArticlesControls {
    constructor(ctrls) {
        this.listArticles = ctrls.get('listArticles');
    }
}
class CmpWidgetArticles extends gs.WrapperGS {
    constructor() {
        super("cmpWidgetArticles");
        this.ctrls = new CmpWidgetArticlesControls(this._controls);
    }
}
exports.CmpWidgetArticles = CmpWidgetArticles;
class CmpWidgetArticlesNewsControls {
    constructor(ctrls) {
        this.listArticles = ctrls.get('listArticles');
    }
}
class CmpWidgetArticlesNews extends gs.WrapperGS {
    constructor() {
        super("cmpWidgetArticlesNews");
        this.ctrls = new CmpWidgetArticlesNewsControls(this._controls);
    }
}
exports.CmpWidgetArticlesNews = CmpWidgetArticlesNews;
class CmpWidgetArticlesSaleControls {
    constructor(ctrls) {
        this.listArticles = ctrls.get('listArticles');
    }
}
class CmpWidgetArticlesSale extends gs.WrapperGS {
    constructor() {
        super("cmpWidgetArticlesSale");
        this.ctrls = new CmpWidgetArticlesSaleControls(this._controls);
    }
}
exports.CmpWidgetArticlesSale = CmpWidgetArticlesSale;
class CmpWidgetCategoriesControls {
    constructor(ctrls) {
    }
}
class CmpWidgetCategories extends gs.WrapperGS {
    constructor() {
        super("cmpWidgetCategories");
        this.ctrls = new CmpWidgetCategoriesControls(this._controls);
    }
}
exports.CmpWidgetCategories = CmpWidgetCategories;
class CmpWidgetLicensesControls {
    constructor(ctrls) {
    }
}
class CmpWidgetLicenses extends gs.WrapperGS {
    constructor() {
        super("cmpWidgetLicenses");
        this.ctrls = new CmpWidgetLicensesControls(this._controls);
    }
}
exports.CmpWidgetLicenses = CmpWidgetLicenses;
class CmpWidgetOfferBaseControls {
    constructor(ctrls) {
        this.cmpSliderControl = ctrls.get('cmpSliderControl');
        this.listProducts = ctrls.get('listProducts');
        this.placeholder = ctrls.get('placeholder');
    }
}
class CmpWidgetOfferBase extends gs.WrapperGS {
    constructor() {
        super("cmpWidgetOffer");
        this.ctrls = new CmpWidgetOfferBaseControls(this._controls);
    }
}
exports.CmpWidgetOfferBase = CmpWidgetOfferBase;
class CmpWidgetOfferGalleryControls {
    constructor(ctrls) {
        this.cmpSliderControl = ctrls.get('cmpSliderControl');
    }
}
class CmpWidgetOfferGallery extends gs.WrapperGS {
    constructor() {
        super("cmpWidgetOfferGallery");
        this.ctrls = new CmpWidgetOfferGalleryControls(this._controls);
    }
}
exports.CmpWidgetOfferGallery = CmpWidgetOfferGallery;
class CmpWidgetPMHistoryControls {
    constructor(ctrls) {
    }
}
class CmpWidgetPMHistory extends gs.WrapperGS {
    constructor() {
        super("cmpWidgetPMHistory");
        this.ctrls = new CmpWidgetPMHistoryControls(this._controls);
    }
}
exports.CmpWidgetPMHistory = CmpWidgetPMHistory;
class CmpWidgetProductCategoryControls {
    constructor(ctrls) {
        this.blockCategory = ctrls.get('blockCategory');
    }
}
class CmpWidgetProductCategory extends gs.WrapperGS {
    constructor() {
        super("cmpWidgetProductCategory");
        this.ctrls = new CmpWidgetProductCategoryControls(this._controls);
    }
}
exports.CmpWidgetProductCategory = CmpWidgetProductCategory;
class CmpWidgetSaleBaseControls {
    constructor(ctrls) {
        this.cmpSliderControl = ctrls.get('cmpSliderControl');
        this.listProducts = ctrls.get('listProducts');
        this.placeholder = ctrls.get('placeholder');
    }
}
class CmpWidgetSaleBase extends gs.WrapperGS {
    constructor() {
        super("cmpWidgetSale");
        this.ctrls = new CmpWidgetSaleBaseControls(this._controls);
    }
}
exports.CmpWidgetSaleBase = CmpWidgetSaleBase;
class CmpWidgetSupplierControls {
    constructor(ctrls) {
    }
}
class CmpWidgetSupplier extends gs.WrapperGS {
    constructor() {
        super("cmpWidgetSupplier");
        this.ctrls = new CmpWidgetSupplierControls(this._controls);
    }
}
exports.CmpWidgetSupplier = CmpWidgetSupplier;
class LayoutAdminControls {
    constructor(ctrls) {
        this.cmpPopRightAuth = ctrls.get('cmpPopRightAuth');
        this.cmpLeftMenu = ctrls.get('cmpLeftMenu');
        this.pageContainer = ctrls.get('pageContainer');
    }
}
class LayoutAdmin extends gs.WrapperGS {
    constructor() {
        super("layoutAdmin");
        this.ctrls = new LayoutAdminControls(this._controls);
    }
}
exports.LayoutAdmin = LayoutAdmin;
class LayoutDesktopBaseControls {
    constructor(ctrls) {
        this.cmpPopRightAuth = ctrls.get('cmpPopRightAuth');
        this.cmpPopCallbackDialog = ctrls.get('cmpPopCallbackDialog');
        this.topMenu = ctrls.get('topMenu');
        this.topMenuMobile = ctrls.get('topMenuMobile');
        this.breadcrumbs = ctrls.get('breadcrumbs');
        this.pageContainer = ctrls.get('pageContainer');
        this.footer = ctrls.get('footer');
        this.bottomMenu = ctrls.get('bottomMenu');
    }
}
class LayoutDesktopBase extends gs.WrapperGS {
    constructor() {
        super("layoutDesktop");
        this.ctrls = new LayoutDesktopBaseControls(this._controls);
    }
}
exports.LayoutDesktopBase = LayoutDesktopBase;
class Page404Controls {
    constructor(ctrls) {
    }
}
class Page404 extends gs.WrapperGS {
    constructor() {
        super("page404");
        this.ctrls = new Page404Controls(this._controls);
    }
}
exports.Page404 = Page404;
class PageAboutCompanyControls {
    constructor(ctrls) {
    }
}
class PageAboutCompany extends gs.WrapperGS {
    constructor() {
        super("pageAboutCompany");
        this.ctrls = new PageAboutCompanyControls(this._controls);
    }
}
exports.PageAboutCompany = PageAboutCompany;
class PageAdminChatControls {
    constructor(ctrls) {
        this.btnBack = ctrls.get('btnBack');
        this.lTitleCreate = ctrls.get('lTitleCreate');
        this.lName = ctrls.get('lName');
        this.lEmail = ctrls.get('lEmail');
        this.lPhone = ctrls.get('lPhone');
        this.lDate = ctrls.get('lDate');
        this.btnSend = ctrls.get('btnSend');
        this.btnDelete = ctrls.get('btnDelete');
    }
}
class PageAdminChat extends gs.WrapperGS {
    constructor() {
        super("pageAdminChat");
        this.ctrls = new PageAdminChatControls(this._controls);
    }
}
exports.PageAdminChat = PageAdminChat;
class PageAdminCreateSearchItemControls {
    constructor(ctrls) {
        this.btnBack = ctrls.get('btnBack');
        this.lTitleCreate = ctrls.get('lTitleCreate');
        this.lTitleEdit = ctrls.get('lTitleEdit');
    }
}
class PageAdminCreateSearchItem extends gs.WrapperGS {
    constructor() {
        super("pageAdminCreateSearchItem");
        this.ctrls = new PageAdminCreateSearchItemControls(this._controls);
    }
}
exports.PageAdminCreateSearchItem = PageAdminCreateSearchItem;
class PageAdminCreateUserControls {
    constructor(ctrls) {
        this.btnBack = ctrls.get('btnBack');
        this.btnOpenSelect = ctrls.get('btnOpenSelect');
        this.selectRole = ctrls.get('selectRole');
    }
}
class PageAdminCreateUser extends gs.WrapperGS {
    constructor() {
        super("pageAdminCreateUser");
        this.ctrls = new PageAdminCreateUserControls(this._controls);
    }
}
exports.PageAdminCreateUser = PageAdminCreateUser;
class PageAdminEmptyControls {
    constructor(ctrls) {
    }
}
class PageAdminEmpty extends gs.WrapperGS {
    constructor() {
        super("pageAdminEmpty");
        this.ctrls = new PageAdminEmptyControls(this._controls);
    }
}
exports.PageAdminEmpty = PageAdminEmpty;
class PageAdminHHAnswersControls {
    constructor(ctrls) {
        this.btnBack = ctrls.get('btnBack');
        this.listApplications = ctrls.get('listApplications');
    }
}
class PageAdminHHAnswers extends gs.WrapperGS {
    constructor() {
        super("pageAdminHHAnswers");
        this.ctrls = new PageAdminHHAnswersControls(this._controls);
    }
}
exports.PageAdminHHAnswers = PageAdminHHAnswers;
class PageAdminListControls {
    constructor(ctrls) {
        this.lTitle = ctrls.get('lTitle');
        this.btnNew = ctrls.get('btnNew');
        this.btnDelete = ctrls.get('btnDelete');
        this.cmpPagination = ctrls.get('cmpPagination');
        this.blockList = ctrls.get('blockList');
        this.cmpFilter = ctrls.get('cmpFilter');
        this.headArticleInfo = ctrls.get('headArticleInfo');
        this.headArticleNews = ctrls.get('headArticleNews');
        this.headHH = ctrls.get('headHH');
        this.headProdQuestion = ctrls.get('headProdQuestion');
        this.headProdReview = ctrls.get('headProdReview');
        this.headSupport = ctrls.get('headSupport');
        this.headUser = ctrls.get('headUser');
    }
}
class PageAdminList extends gs.WrapperGS {
    constructor() {
        super("pageAdminList");
        this.ctrls = new PageAdminListControls(this._controls);
    }
}
exports.PageAdminList = PageAdminList;
class PageAdminNewArticleControls {
    constructor(ctrls) {
        this.btnBack = ctrls.get('btnBack');
        this.lPageTitle = ctrls.get('lPageTitle');
        this.blockTag = ctrls.get('blockTag');
        this.cmpHtmlEditor = ctrls.get('cmpHtmlEditor');
        this.cmpPublicationControl = ctrls.get('cmpPublicationControl');
    }
}
class PageAdminNewArticle extends gs.WrapperGS {
    constructor() {
        super("pageAdminNewArticle");
        this.ctrls = new PageAdminNewArticleControls(this._controls);
    }
}
exports.PageAdminNewArticle = PageAdminNewArticle;
class PageAdminNewArticleSaleControls {
    constructor(ctrls) {
        this.btnBack = ctrls.get('btnBack');
        this.lPageTitle = ctrls.get('lPageTitle');
        this.cmpPublicationControl = ctrls.get('cmpPublicationControl');
    }
}
class PageAdminNewArticleSale extends gs.WrapperGS {
    constructor() {
        super("pageAdminNewArticleSale");
        this.ctrls = new PageAdminNewArticleSaleControls(this._controls);
    }
}
exports.PageAdminNewArticleSale = PageAdminNewArticleSale;
class PageAdminNewHHControls {
    constructor(ctrls) {
        this.btnBack = ctrls.get('btnBack');
        this.lPageTitle = ctrls.get('lPageTitle');
        this.cmpPublicationControl = ctrls.get('cmpPublicationControl');
    }
}
class PageAdminNewHH extends gs.WrapperGS {
    constructor() {
        super("pageAdminNewHH");
        this.ctrls = new PageAdminNewHHControls(this._controls);
    }
}
exports.PageAdminNewHH = PageAdminNewHH;
class PageAdminProfileConfigControls {
    constructor(ctrls) {
        this.btnBack = ctrls.get('btnBack');
        this.lTitleCreate = ctrls.get('lTitleCreate');
        this.imgProfilePhoto = ctrls.get('imgProfilePhoto');
        this.btnChangePhoto = ctrls.get('btnChangePhoto');
        this.btnOpenSelect = ctrls.get('btnOpenSelect');
        this.selectRole = ctrls.get('selectRole');
    }
}
class PageAdminProfileConfig extends gs.WrapperGS {
    constructor() {
        super("pageAdminProfileConfig");
        this.ctrls = new PageAdminProfileConfigControls(this._controls);
    }
}
exports.PageAdminProfileConfig = PageAdminProfileConfig;
class PageAdminReviewControls {
    constructor(ctrls) {
        this.btnBack = ctrls.get('btnBack');
        this.lTitleCreate = ctrls.get('lTitleCreate');
        this.lName = ctrls.get('lName');
        this.lEmail = ctrls.get('lEmail');
        this.lPhone = ctrls.get('lPhone');
        this.lDate = ctrls.get('lDate');
        this.btnApprove = ctrls.get('btnApprove');
        this.btnDelete = ctrls.get('btnDelete');
    }
}
class PageAdminReview extends gs.WrapperGS {
    constructor() {
        super("pageAdminReview");
        this.ctrls = new PageAdminReviewControls(this._controls);
    }
}
exports.PageAdminReview = PageAdminReview;
class PageAdminSelectPromotionControls {
    constructor(ctrls) {
        this.btnBack = ctrls.get('btnBack');
        this.iSearch = ctrls.get('iSearch');
        this.listPromotions = ctrls.get('listPromotions');
        this.btnAdd = ctrls.get('btnAdd');
        this.btnClear = ctrls.get('btnClear');
    }
}
class PageAdminSelectPromotion extends gs.WrapperGS {
    constructor() {
        super("pageAdminSelectPromotion");
        this.ctrls = new PageAdminSelectPromotionControls(this._controls);
    }
}
exports.PageAdminSelectPromotion = PageAdminSelectPromotion;
class PageArticlesInfoControls {
    constructor(ctrls) {
        this.listArticles = ctrls.get('listArticles');
    }
}
class PageArticlesInfo extends gs.WrapperGS {
    constructor() {
        super("pageArticlesInfo");
        this.ctrls = new PageArticlesInfoControls(this._controls);
    }
}
exports.PageArticlesInfo = PageArticlesInfo;
class PageArticlesNewsControls {
    constructor(ctrls) {
        this.blockArticles = ctrls.get('blockArticles');
    }
}
class PageArticlesNews extends gs.WrapperGS {
    constructor() {
        super("pageArticlesNews");
        this.ctrls = new PageArticlesNewsControls(this._controls);
    }
}
exports.PageArticlesNews = PageArticlesNews;
class PageArticlesNewsAndInfoControls {
    constructor(ctrls) {
        this.listNews = ctrls.get('listNews');
        this.listArticles = ctrls.get('listArticles');
    }
}
class PageArticlesNewsAndInfo extends gs.WrapperGS {
    constructor() {
        super("pageArticlesNewsAndInfo");
        this.ctrls = new PageArticlesNewsAndInfoControls(this._controls);
    }
}
exports.PageArticlesNewsAndInfo = PageArticlesNewsAndInfo;
class PageArticlesSaleControls {
    constructor(ctrls) {
        this.listArticles = ctrls.get('listArticles');
    }
}
class PageArticlesSale extends gs.WrapperGS {
    constructor() {
        super("pageArticlesSale");
        this.ctrls = new PageArticlesSaleControls(this._controls);
    }
}
exports.PageArticlesSale = PageArticlesSale;
class PageCartControls {
    constructor(ctrls) {
        this.cbSelectedAll = ctrls.get('cbSelectedAll');
        this.btnDeleteSelected = ctrls.get('btnDeleteSelected');
        this.listProducts = ctrls.get('listProducts');
        this.cmpCartTotal = ctrls.get('cmpCartTotal');
    }
}
class PageCart extends gs.WrapperGS {
    constructor() {
        super("pageCart");
        this.ctrls = new PageCartControls(this._controls);
    }
}
exports.PageCart = PageCart;
class PageContactsControls {
    constructor(ctrls) {
    }
}
class PageContacts extends gs.WrapperGS {
    constructor() {
        super("pageContacts");
        this.ctrls = new PageContactsControls(this._controls);
    }
}
exports.PageContacts = PageContacts;
class PageDocumentControls {
    constructor(ctrls) {
        this.btnBack = ctrls.get('btnBack');
        this.lTitle = ctrls.get('lTitle');
        this.nav = ctrls.get('nav');
        this.content = ctrls.get('content');
    }
}
class PageDocument extends gs.WrapperGS {
    constructor() {
        super("pageDocument");
        this.ctrls = new PageDocumentControls(this._controls);
    }
}
exports.PageDocument = PageDocument;
class PageHeadHuntControls {
    constructor(ctrls) {
    }
}
class PageHeadHunt extends gs.WrapperGS {
    constructor() {
        super("pageHeadHunt");
        this.ctrls = new PageHeadHuntControls(this._controls);
    }
}
exports.PageHeadHunt = PageHeadHunt;
class PageLegalInfoControls {
    constructor(ctrls) {
    }
}
class PageLegalInfo extends gs.WrapperGS {
    constructor() {
        super("pageLegalInfo");
        this.ctrls = new PageLegalInfoControls(this._controls);
    }
}
exports.PageLegalInfo = PageLegalInfo;
class PageLoadingControls {
    constructor(ctrls) {
    }
}
class PageLoading extends gs.WrapperGS {
    constructor() {
        super("pageLoading");
        this.ctrls = new PageLoadingControls(this._controls);
    }
}
exports.PageLoading = PageLoading;
class PageMainControls {
    constructor(ctrls) {
        this.cmpWidgetOfferGallery = ctrls.get('cmpWidgetOfferGallery');
    }
}
class PageMain extends gs.WrapperGS {
    constructor() {
        super("pageMain");
        this.ctrls = new PageMainControls(this._controls);
    }
}
exports.PageMain = PageMain;
class PageNewsControls {
    constructor(ctrls) {
    }
}
class PageNews extends gs.WrapperGS {
    constructor() {
        super("pageNews");
        this.ctrls = new PageNewsControls(this._controls);
    }
}
exports.PageNews = PageNews;
class PageOrderNewControls {
    constructor(ctrls) {
        this.blockCustomer = ctrls.get('blockCustomer');
        this.btnBack = ctrls.get('btnBack');
        this.blockDetails = ctrls.get('blockDetails');
        this.iName = ctrls.get('iName');
        this.iPhone = ctrls.get('iPhone');
        this.iEmail = ctrls.get('iEmail');
        this.iComment = ctrls.get('iComment');
        this.btnGetPickUp = ctrls.get('btnGetPickUp');
        this.btnGetDelivery = ctrls.get('btnGetDelivery');
        this.blockGetDelivery = ctrls.get('blockGetDelivery');
        this.optionsSelected = ctrls.get('optionsSelected');
        this.optionsList = ctrls.get('optionsList');
        this.iDeliveryAddress = ctrls.get('iDeliveryAddress');
        this.blockGetPickUp = ctrls.get('blockGetPickUp');
        this.blockMap = ctrls.get('blockMap');
        this.cmpCartTotal = ctrls.get('cmpCartTotal');
        this.blockOrderCreated = ctrls.get('blockOrderCreated');
        this.lOrderId_Created = ctrls.get('lOrderId_Created');
        this.blockOrderNeedConfirm = ctrls.get('blockOrderNeedConfirm');
        this.lOrderId_NeedConfirm = ctrls.get('lOrderId_NeedConfirm');
        this.blockOrderNeedPay = ctrls.get('blockOrderNeedPay');
        this.lOrderId_NeedPay = ctrls.get('lOrderId_NeedPay');
    }
}
class PageOrderNew extends gs.WrapperGS {
    constructor() {
        super("pageOrderNew");
        this.ctrls = new PageOrderNewControls(this._controls);
    }
}
exports.PageOrderNew = PageOrderNew;
class PageProductControls {
    constructor(ctrls) {
        this.lName = ctrls.get('lName');
        this.statusOk = ctrls.get('statusOk');
        this.lRemainderCount = ctrls.get('lRemainderCount');
        this.statusNone = ctrls.get('statusNone');
        this.statusDelivery = ctrls.get('statusDelivery');
        this.blockRate = ctrls.get('blockRate');
        this.lRate = ctrls.get('lRate');
        this.aReviews = ctrls.get('aReviews');
        this.lReviewsCount = ctrls.get('lReviewsCount');
        this.aQuestions = ctrls.get('aQuestions');
        this.lQuestionsCount = ctrls.get('lQuestionsCount');
        this.lArticle = ctrls.get('lArticle');
        this.btnCompare = ctrls.get('btnCompare');
        this.btnShare = ctrls.get('btnShare');
        this.blockImgPreview = ctrls.get('blockImgPreview');
        this.imgPreview = ctrls.get('imgPreview');
        this.btnGalleryPrev = ctrls.get('btnGalleryPrev');
        this.listImgs = ctrls.get('listImgs');
        this.btnGalleryNext = ctrls.get('btnGalleryNext');
        this.list = ctrls.get('list');
        this.aDetails = ctrls.get('aDetails');
        this.lPrice = ctrls.get('lPrice');
        this.lPriceOld = ctrls.get('lPriceOld');
        this.lPriceDiscount = ctrls.get('lPriceDiscount');
        this.lPriceTimer = ctrls.get('lPriceTimer');
        this.blockPriceBonus = ctrls.get('blockPriceBonus');
        this.lPriceBonus = ctrls.get('lPriceBonus');
        this.btnQtyMinus = ctrls.get('btnQtyMinus');
        this.lQty = ctrls.get('lQty');
        this.lPriceTotal = ctrls.get('lPriceTotal');
        this.btnQtyPlus = ctrls.get('btnQtyPlus');
        this.btnAddToCart = ctrls.get('btnAddToCart');
        this.btnFavorite = ctrls.get('btnFavorite');
        this.btnTabMain = ctrls.get('btnTabMain');
        this.btnTabDetails = ctrls.get('btnTabDetails');
        this.btnTabReviews = ctrls.get('btnTabReviews');
        this.lBtnReviewsCount = ctrls.get('lBtnReviewsCount');
        this.btnTabFiles = ctrls.get('btnTabFiles');
        this.lBtnFilesCount = ctrls.get('lBtnFilesCount');
        this.btnTabQuestions = ctrls.get('btnTabQuestions');
        this.lBtnQuestionsCount = ctrls.get('lBtnQuestionsCount');
        this.cmpTabMain = ctrls.get('cmpTabMain');
        this.cmpTabDetails = ctrls.get('cmpTabDetails');
        this.cmpTabReviews = ctrls.get('cmpTabReviews');
        this.cmpTabQuestions = ctrls.get('cmpTabQuestions');
    }
}
class PageProduct extends gs.WrapperGS {
    constructor() {
        super("pageProduct");
        this.ctrls = new PageProductControls(this._controls);
    }
}
exports.PageProduct = PageProduct;
class PageProductAddCommentControls {
    constructor(ctrls) {
        this.lPrivacyWarning = ctrls.get('lPrivacyWarning');
    }
}
class PageProductAddComment extends gs.WrapperGS {
    constructor() {
        super("pageProductAddComment");
        this.ctrls = new PageProductAddCommentControls(this._controls);
    }
}
exports.PageProductAddComment = PageProductAddComment;
class PageProductsControls {
    constructor(ctrls) {
        this.lHeader = ctrls.get('lHeader');
        this.listTags = ctrls.get('listTags');
        this.cmpWidgetCategories = ctrls.get('cmpWidgetCategories');
        this.cmpFilterLine = ctrls.get('cmpFilterLine');
        this.listProducts = ctrls.get('listProducts');
        this.cmpPagination = ctrls.get('cmpPagination');
    }
}
class PageProducts extends gs.WrapperGS {
    constructor() {
        super("pageProducts");
        this.ctrls = new PageProductsControls(this._controls);
    }
}
exports.PageProducts = PageProducts;
class PageProductsFavouritesBaseControls {
    constructor(ctrls) {
        this.lHeader = ctrls.get('lHeader');
        this.blockEmpty = ctrls.get('blockEmpty');
        this.blockFavorite = ctrls.get('blockFavorite');
        this.cmpFilterLine = ctrls.get('cmpFilterLine');
        this.listProducts = ctrls.get('listProducts');
        this.cmpPagination = ctrls.get('cmpPagination');
    }
}
class PageProductsFavouritesBase extends gs.WrapperGS {
    constructor() {
        super("pageProductsFavourites");
        this.ctrls = new PageProductsFavouritesBaseControls(this._controls);
    }
}
exports.PageProductsFavouritesBase = PageProductsFavouritesBase;
class PageProfileControls {
    constructor(ctrls) {
        this.btnBack = ctrls.get('btnBack');
        this.lPageTitle = ctrls.get('lPageTitle');
        this.navDesk = ctrls.get('navDesk');
        this.navMob = ctrls.get('navMob');
        this.blockTabs = ctrls.get('blockTabs');
        this.tabConfig = ctrls.get('tabConfig');
        this.tabOrders = ctrls.get('tabOrders');
        this.tabProductsFavourites = ctrls.get('tabProductsFavourites');
        this.tabFAQ = ctrls.get('tabFAQ');
        this.tabNotifications = ctrls.get('tabNotifications');
        this.tabSupport = ctrls.get('tabSupport');
    }
}
class PageProfile extends gs.WrapperGS {
    constructor() {
        super("pageProfile");
        this.ctrls = new PageProfileControls(this._controls);
    }
}
exports.PageProfile = PageProfile;
//# sourceMappingURL=tmpls.js.map